import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { MessageService, SelectItem } from 'primeng/api/';
import { BootstrapAuthService } from '../../auth/services/bootstrap-auth.service';
import { OptionLicense } from '../../models/option-licence.model';
import { TenantLicense } from '../../models/tenant-license.model';
import { TenantLicenseService } from '../../services/tenant-license.service';
import {UuidLicense} from "../../models/uuid-license.model";

@Component({
  selector: 'iw-dashboard',
  templateUrl: './iw-dashboard.component.html',
  providers: [MessageService],
})
export class IwDashboardComponent {
  public display?: boolean;
  public displayUuid?: boolean;
  public displayUpdate?: boolean;
  public displayUpdateUuid?: boolean;
  public tenants: TenantLicense[] = [];
  public uuids: UuidLicense[] = [];
  public tenant: TenantLicense = new TenantLicense({});
  public uuidData: UuidLicense = new UuidLicense({});
  public expirationDate?: Date;
  public optionsList?: OptionLicense[];
  public newOptionsList?: OptionLicense[];
  public langs: any[] = [
    { name: 'en', flag: 'en.png' },
    { name: 'fr', flag: 'fr.png' },
  ];
  public currentLang: any;
  public popUpName?: string;
  public tenantStatus?: SelectItem[];
  public currentName: string;

  constructor(
    public readonly tenantLicenseService: TenantLicenseService,
    private readonly bootstrapAuthService: BootstrapAuthService,
    private readonly translate: TranslateService,
  ) {
    this.initTranslate();
    this.resetOptionList();

    this.currentName = bootstrapAuthService.getName();
  }

  public showDialog(show: boolean): void {
    this.display = show;
    this.displayUpdate = false;
    this.popUpName = this.translate.instant('Create Client');
    this.tenant = new TenantLicense({});
    this.expirationDate = new Date(moment().add(1, 'year').toString());
    this.setTenantStatus();
  }

  public showDialogCreateUuid(show: boolean): void {
    this.displayUuid = show;
    this.displayUpdate = false;
    this.popUpName = this.translate.instant('Create Uuid');
    this.uuidData = new UuidLicense({});
    this.expirationDate = new Date(moment().add(1, 'year').toString());
  }
  public showUpdateDialogUuid(uuidData: UuidLicense): void {
    this.popUpName = this.translate.instant('Update Uuid License');
    this.displayUpdate = true;
    this.displayUpdateUuid = true;
    this.setTenantStatus();
    this.displayUuid = true;
    this.displayUpdateUuid = true;
    this.uuidData = new UuidLicense(uuidData);
    if (uuidData && uuidData.expirationDate) {
      this.expirationDate = uuidData
        ? uuidData.expirationDate.toDate()
        : new Date(moment().add(1, 'year').toString());
    }
  }

  public showUpdateDialog(tenant: TenantLicense): void {
    this.setTenantStatus();
    this.popUpName = this.translate.instant('Update Client');
    this.tenantLicenseService.getOptions(tenant.tenant).subscribe((u: any) => {
      const options = u._embedded.licenseOption;
      if (options.length === 0) {
        this.resetOptionList();
      }
      this.optionsList?.forEach((option) => {
        options.find((o: OptionLicense) => {
          if (o.optionName === option.optionName) {
            option.active = true;
            option.id = o.id;
          }
        });
        option.tenant = tenant.tenant;
      });
      this.newOptionsList = [];
      this.optionsList?.forEach((val) =>
        this.newOptionsList?.push(Object.assign({}, val)),
      );
    });

    this.tenantLicenseService.getUsers(tenant.tenant).subscribe((u: any) => {
      tenant.registeredLicenseUsers = u._embedded.licenseUserLogged;
      this.tenant = new TenantLicense(tenant);
    });

    this.display = true;
    this.displayUpdate = true;
    this.tenant = new TenantLicense(tenant);
    this.expirationDate = tenant
      ? tenant.expirationDate.toDate()
      : new Date(moment().add(1, 'year').toString());
  }

  public updateTenant(tenants: TenantLicense[]): void {
    this.tenants = tenants;
  }

  public updateUuid(uuids: UuidLicense[]): void {
    this.uuids = uuids;
  }

  public updateTenantOptions(options: OptionLicense[]): void {
    this.newOptionsList?.forEach((option: OptionLicense) => {
      // tslint:disable-next-line: cyclomatic-complexity
      options.forEach((o: OptionLicense) => {
        if (
          o.optionName === option.optionName &&
          option.active !== o.active &&
          o.active
        ) {
          o.id = undefined;
          this.tenantLicenseService.setOption(o).subscribe();
        }
        if (
          o.optionName === option.optionName &&
          option.active !== o.active &&
          !o.active
        ) {
          // tslint:disable-next-line: no-non-null-assertion
          this.tenantLicenseService.deleteOption(o.id!).subscribe();
        }
      });
      this.tenants = this.tenantLicenseService.getTenant();
    });
  }

  public handleSwitchLanguageClick(): void {
    this.translate.use(this.currentLang.name === 'en' ? 'fr' : 'en');
  }

  public logout(): void {
    this.bootstrapAuthService.logout();
  }

  private  initTranslate(): void {
    // Set the default language for translation strings and the current language.
    const browserLang = this.translate.getBrowserLang();
    if (this.currentLang) {
      this.translate.use(this.currentLang.name);
    } else if (browserLang && browserLang === 'fr') {
      this.translate.use(this.translate.getBrowserLang());
      this.currentLang = { name: 'fr', flag: 'fr.png' };
    } else {
      this.translate.use('en'); // Set your language here
      this.currentLang = { name: 'en', flag: 'en.png' };
    }
  }

  private setTenantStatus(): void {
    this.tenantStatus = [
      { label: this.translate.instant('ACTIVE'), value: 'ACTIVE' },
      { label: this.translate.instant('EXPIRED'), value: 'EXPIRED' },
    ];
  }
  private resetOptionList(): void {
    this.optionsList = [];
    this.optionsList.push(
      new OptionLicense({ optionName: 'Swissdec', active: false }),
    );
    this.optionsList.push(
      new OptionLicense({ optionName: 'SMS Alert', active: false }),
    );
    this.optionsList.push(
      new OptionLicense({ optionName: 'M-Files', active: false }),
    );
    this.optionsList.push(
      new OptionLicense({ optionName: 'S3 as default storage', active: false }),
    );
    this.optionsList.push(
      new OptionLicense({ optionName: 'Index fulltextdocs', active: false }),
    );
    this.optionsList.push(
      new OptionLicense({ optionName: 'InterijobWebAccess', active: false }),
    );
    this.optionsList.push(
      new OptionLicense({ optionName: 'Sign Request', active: false }),
    );
  }
}
